<template>
  <div class="list sell shipCsv">
    <div v-if="load">
      <vue-loading style="position: fixed;z-index: 100;left: 25%;" type="spin" color="#333" :size="{ width: '50%', height: '50%' }"></vue-loading>
      <div class="over" style="opacity: 0.7;width: 100%;height: 100%;background: #fefefe;position: fixed;top: 0;left: 0;z-index: 99;"></div>
    </div>
    
    <div class="auctionRegister">
      <h1 class="topTitle">取引中商品管理</h1><div style="display:none;">{{ modalItems }}</div>
      <!-- <button @click="test">test</button> -->
      
      <div class="container">
        
        <div class="outer-menu">
                <input class="checkbox-toggle" v-model="isShowSerchBox" type="checkbox" />
                <div class="hamburger" :class="{ searchIcon: !isShowSerchBox}" @click="isShowSerchBox = !isShowSerchBox">
                    <div v-if="isShowSerchBox"></div>
                </div>
                <div class="menu">
                    <div class="searchArea">
                        <div class="searchBox">
                            <h2 class="itemTitle">検索</h2> 
                            <ul>
                                <li>
                                <label for="itemName">出品ID:</label>
                                <input type="text" placeholder="出品ID" id="sellId" v-model="serchItem.sellId" tabindex="1"/>
                            </li>
                            <li>
                                <label for="itemName">ユーザー名:</label>
                                <select class="sltBox" v-model="serchItem.userId">
                                    <option value="" disabled selected hidden>選択してください</option>
                                    <option v-for="item in userList" :value="item.USER_ID" :key="item.USER_ID">
                                        {{ item.USER_NAME }}
                                    </option>
                                </select>
                                
                            </li>
                            <li class="serchDateBox">
                                <label for="serchIsSelled">未出力売買のみ表示:</label><br>
                               <input type="checkbox" v-model="serchItem.isSelled" id="serchIsSelled" >
                               <label class="checkbox03" for="serchIsSelled"></label>
                            </li>
                        </ul>
                        <div class="btnBox">
                            <button class="btn" @click="isShowSerchBox = !isShowSerchBox, clear()">クリア</button>
                            <button class="btn" @click="isShowSerchBox = !isShowSerchBox, serch()">検索</button>
                        </div>
                        </div>
                    </div>
                </div>
            </div>
            <div id="ww">
            <div class="scrollbar" id="scrollbar"><div id="scrollInner" class="inner" @scroll.passive="onScroll"></div></div>
          </div>
          <div id="scrollbox" class="sellersV item-wrap scrollbox">
              <table id="csvTable" class="itemTable inner-content" style="border-collapse: separate;">
                <tr>
                        <th class="titleChk">確認</th>
                        <th class="listTitle">操作</th>
                        <th class="listTitle">出品者名</th>
                        <th class="listTitle">ステータス</th>
                        <th class="listTitle" >売買日</th>
                        <th class="titleChk">コメント数</th>
                        <th class="listTitle" >商品ページへ</th>
                        <th class="listTitle" >郵便番号</th>
                        <th class="listTitle">住所</th>
                        <th class="listTitle">名前</th>
                        <th class="listTitle">名前カナ</th>
                        <th class="titleChk" style="min-width:120px;">CSV/PDF出力</th>
                        <th class="titleChk">内容物(CSV出力用)</th>

                      </tr>
                      <tr v-for="(item, i) in getItems" :key="i">
                        <td class="listItem">
                          <!-- 確認 -->
                          <input type="checkbox" v-model="item.SEND_FLG" :id="'serchIsSelled' + i" @change="chkChange(item)">
                          <label class="checkbox03" :for="'serchIsSelled' + i"></label>
                        </td>
                        <!-- 操作 -->
                        <td class="listItem"><button class="btn remove" style="min-width:0;" @click="modal(item)">操作する</button></td>
                        <!-- 出品者名 -->
                        <td class="listItem">{{ item.USER_NAME }}</td>
                        <!-- ステータス -->
                        <td class="listItem" >{{ item.status }}</td>
                        <!-- 売買日 -->
                        <td class="listItem" >{{ item.SELL_DATE }}</td>
                        
                        <!-- コメント件数 -->
                        <td class="listItem">{{ item.COM_COUNT }}件</td>
                        <!-- 商品ページリンク -->
                        <td class="listItem" ><a :href="`https://jp.mercari.com/item/${item.SELL_ID}`" target="_blank" rel="noopener noreferrer" class="link">商品ページ</a></td>
                        
                        <!-- 郵便番号 -->
                        <td class="listItem" >{{ item.ZIP_CODE }}</td>
                        <!-- 住所 -->
                        <td class="listItem"><div><span>{{ item.ADDRESS }}</span></div></td>
                        <!-- 名前 -->
                        <td class="listItem">{{ item.NAME }}</td>
                        <!-- 名前カナ -->
                        <td class="listItem">{{ item.NAME_KANA }}</td>
                        <td class="listItem">
                          <!-- CSV/PDF出力 -->
                          <span>CRP</span>
                          <input type="checkbox" v-model="item.OUT_CSV" :id="'outputCsv' + i">
                          <label class="checkbox03" style="padding-bottom: 0;margin-bottom: 4px;" :for="'outputCsv' + i"></label><br>
                          <span>定形外</span>
                          <input type="checkbox" v-model="item.OUT_PDF" :id="'outputPDF' + i">
                          <label class="checkbox03" style="padding-bottom: 0;margin-bottom: 4px;" :for="'outputPDF' + i"></label>
                        </td>
                        <td class="listItem">
                          <!-- CSV出力カテゴリ -->
                          <select class="sltBox" v-model="item.Category">
                              <option value="" disabled selected hidden>選択してください</option>
                              <option v-for="c in categoryList" :value="c.ID" :key="c.ID">
                                  {{ c.CATEGORY_NAME }}
                              </option>
                          </select>
                        </td>
                      </tr>
              </table>
          </div>
        <div class="item-wrap" style="overflow: hidden;">
          
          <button class="btn modif" @click="createCsv">CSV or PDF 出力する</button>
          <div class="pdgTop10">
                    <vuejs-paginate
                    :page-count="getPaginateCount"
                    :prev-text="'<'"
                    :next-text="'>'"
                    :click-handler="paginateClickCallback"
                    :container-class="'pagination justify-content-center'"
                    :page-class="'page-item'"
                    :page-link-class="'page-link'"
                    :prev-class="'page-item'"
                    :prev-link-class="'page-link'"
                    :next-class="'page-item'"
                    :next-link-class="'page-link'"
                    :first-last-button="true"
                    :first-button-text="'<<'"
                    :last-button-text="'>>'"
                    ></vuejs-paginate>
                </div>
                <div class="overlay" v-show="isShow">
                  <div class="modalodal">
                    <div class="swal2-popup swal2-modal swal2-show" style="display: grid;width: 100%;padding: 5px;height: 600px;overflow: auto;">
                      <table class="itemTable">
                        <tr>
                          <th class="listTitle name" style="width: 30%;"> コメント送信者名 </th>
                          <th class="listTitle name" style="width: 30%;"> コメント送信日時 </th>
                          <th class="listTitle com"> コメント </th>
                        </tr>
                        <tr v-for="it in modalItems.coms">
                          <td>{{ it.USER_NAME }}</td>
                          <td>{{ it.COMMENT_DATE }}</td>
                          <td>{{ it.COMMENT }}</td>
                        </tr>
                      </table>
                      <div>
                        <h5 @click="mdoalType = 'msg'">メッセージを返信する</h5>
                        <div v-show="mdoalType == 'msg'"><textarea rows="5" v-model="postItem.com"></textarea><button class="btn modif" @click="setComment">返信する</button></div>
                      </div>
                      <div>
                        <h5 @click="mdoalType = 'hyouka'" v-show="modalItems.STATUS == 'wait_shipping' && modalItems.SHIPPING_NOTIFICATION != '1' && modalItems.SHIPPING_NOTIFICATION != '2'">発送通知をする</h5>
                        <div v-show="mdoalType == 'hyouka'"><button class="btn modif" @click="editItem('1','0', 'setInfo')">発送通知する</button></div>
                      </div>
                      <div>
                        <h5 @click="mdoalType = 'hassou'" v-show="modalItems.STATUS == 'wait_done' && modalItems.SHIPPING_NOTIFICATION != '1' && modalItems.EVALUATION != '2' ">評価をする</h5>
                        <div v-show="mdoalType == 'hassou'">
                          <textarea rows="5" placeholder="評価メッセージを入力してください。" v-model="postItem.message"></textarea>
                          <button class="btn modif" @click="editItem('0','1', 'setInfo2')">評価する</button>
                        </div>
                      </div>
                      <div class="swal2-actions"><button class="swal2-cancel swal2-styled" @click="reModal">戻る</button></div>
                    </div>
                  </div>
                </div>
        </div>

        <div class="btnBox subArea">
          <button class="btn repage" @click="returnPage">戻る</button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

import VueJsPaginate from "vuejs-paginate";
import { VueLoading } from 'vue-loading-template'
import Encoding from 'encoding-japanese';
import Datepicker from "vuejs-datepicker";
import { ja } from "vuejs-datepicker/dist/locale";

import {userRepository} from '@/Repositories/userRepository.js';
import { tradingRepository } from "@/Repositories/tradingRepository.js";
import {cApiRepsitory} from '@/Repositories/cApiRepsitory.js'
import {googleRepository} from '@/Repositories/googleRepository.js'
export default {
  data() {
    return {
      /******************
       * Datepicker設定
       ******************/
      ja: ja,
      disabledDates: {
        from: new Date(),
      },
      /******************
       * 検索用
       ******************/
      serchItem:{
        sellId:null,
        userId:null,
        isSelled:false
      },
      userInfo:{},
      isShowSerchBox:false,
      userList:[],
      /******************
       * 表示・非表示フラグ
       ******************/
      isShow:false,
      tmp:'',
      load: false,
      /******************
       * 出力
       ******************/
      items:[],
      categoryList:[],
      postItem:[],
      modalItems:[],
      mdoalType:'',
      currentPage: 1,
      perPage: 20
    }
  },
  components: {
    "vuejs-paginate": VueJsPaginate,
    Datepicker,
    VueLoading,
  },
  methods: {
    // init2(){
    //   const targetClasses = ['wrapper', 'scrollbar']

    //   for(const targetClass of targetClasses) {
    //     document.querySelector(`.${targetClass}`).addEventListener('scroll', function () {
    //       const otherClass = this.className.includes(targetClasses[0]) ? targetClasses[1] : targetClasses[0];
    //       console.log(otherClass)
    //       const left = document.querySelector(`.${targetClass}`).scrollLeft;
    //       document.querySelector(`.${otherClass}`).scrollTo(left, 0);
    //     })
    //   }
    // },
    onScrollXTopBar(e) {
      document.getElementById("content").scrollTo(e.target.scrollLeft, 0);
    },
    onScrollXContent(e) {
      document.getElementById("topbar").scrollTo(e.target.scrollLeft, 0);
    },
    createCsv(){
      
      var j = {};
      j.items = [];
      var tmpJ = this.items.filter(x=> x.OUT_PDF && (x.ZIP_CODE != '-' && x.ADDRESS != '' && x.NAME != ''));
      if(tmpJ.length > 0){
        this.load = true;
        tmpJ = tmpJ.map(x=> [x.ZIP_CODE, x.ADDRESS, x.NAME]);
        j.items = tmpJ;
        googleRepository.methods.update(j).then(response => {
          return response.json();
        })
        .then((json) => {
          this.output_pdf(json.message);
          this.load = false;
        })
        .catch(err => {
          alert('失敗しました。再度やり直してください');
          this.load = false;
        });
      }
      
      var row = 0;
      var tmpArr = this.items.filter(x=> x.OUT_CSV);
      if(tmpArr.length != 0){
        var csv = 'お届け先郵便番号,お届け先氏名,お届け先敬称,お届け先住所1行目,お届け先住所2行目,お届け先住所3行目,お届け先住所4行目,内容品\n';
        for(var arr of tmpArr){
          var category = this.getCategoryName(arr.Category);
          if(category == '') continue;
          row++;
          if(row > 40) {
            this.output_csv(csv);
            csv = 'お届け先郵便番号,お届け先氏名,お届け先敬称,お届け先住所1行目,お届け先住所2行目,お届け先住所3行目,お届け先住所4行目,内容品\n';
          }
          var record = `${arr.ZIP_CODE},${arr.NAME.substring(0,20)},様,${arr.ADDRESS.substring(0,20)},${arr.ADDRESS.length > 20? arr.ADDRESS.substring(20,40):''},${arr.ADDRESS.length > 40? arr.ADDRESS.substring(40,60):''},${arr.ADDRESS.length > 60? arr.ADDRESS.substring(60,80):''},${category.substring(0,15)}\n`;
          csv+= record;
        }
        this.output_csv(csv);
      }
      
      
    },
    output_csv(csv){
      var str = Encoding.stringToCode(csv);
      var convert = Encoding.convert(str, 'sjis', 'unicode');
      var u8a = new Uint8Array(convert);
      let blob = new Blob([u8a], { type: 'text/csv' })
      let link = document.createElement('a')
      link.href = window.URL.createObjectURL(blob)
      link.download = 'template.csv'
      link.click()
    },
    output_pdf(id){
      var url = `https://drive.google.com/uc?export=download&id=${id}`;
      
      let link = document.createElement('a');
      link.href = url;
      link.download = 'template.pdf'
      link.click()
    },
    chkChange(item){
      var sendFlg = item.SEND_FLG?'1':'0' 
      tradingRepository.methods.post({
          user_id: item.USER_ID,
          type: "setSendCheck",
          item_id: item.SELL_ID,
          flg: sendFlg,
      })
    },
    reModal(){
      let vm = this;
      vm.modalItems = {};
      vm.postItem = {};
      vm.isShow = false;
    },
    setComment() {
      let vm = this;
      vm.tmpComList;
      var e = vm.userList[0].PARENT_ID;
      console.log(vm.modalItems);
      tradingRepository.methods.post({
          user_id: vm.postItem.USER_ID,
          type: "setComent",
          item_id: vm.postItem.SELL_ID,
          parent_id: e,
          comment: vm.postItem.com
      }).then(e=>{
        vm.postItem = {},
        vm.$swal("コメント返信登録しました。", "", "success").then(e=>{
          vm.modalItems = {};
          vm.postItem = {};
          vm.isShow = false;
          }
          )
      }
      )
  },
  editItem(hassou, hyouka, type) {
      let s = this;
      s.tmpComList;
      var i = s.userList[0].PARENT_ID;
      tradingRepository.methods.post({
          user_id: s.modalItems.USER_ID,
          type: type,
          parent_id: i,
          itemId: s.modalItems.SELL_ID,
          ship: hassou,
          eva: hyouka,
          comment: s.postItem.com,
          message: s.postItem.message
      }).then(t=>{
        s.modalItems = {};
          s.postItem = {},
          s.$swal("登録しました。", "", "success").then(t=>{
              s.isModal = !1
          }
          )
      }
      )
  },
  
    modal(item){
      let vm = this;
      vm.isShow = true;
      tradingRepository.methods.get({
          type:'getComments',
          item_id:item.SELL_ID
        }).then(r=>{
          vm.modalItems = item;
          vm.postItem = item;
          vm.modalItems.coms = r.data;
          
        });
    },
    paginateClickCallback (pageNum) {
        this.currentPage = Number(pageNum);
    },
    returnPage(){
      let vm = this;
        vm.$router.back();
    },
    getCategory(){
        cApiRepsitory.methods.post({
            "user_id":this.userInfo.USER_ID,
            "type":'getCategory'
        }).then(res=>{
            this.categoryList = res.data;
        })
    },
    getCategoryName(id){
        var category = this.categoryList.find(x=> x.ID == id);
        if(category) return category.CATEGORY_NAME
        else return '';
    },
    init(){
      let vm = this;
      vm.userInfo = vm.$functions.getSStorage('userInfo');
      userRepository.methods.getChild().then(res=>{
          vm.userList = res.data;
          vm.getCategory();
        tradingRepository.methods.get({
          type:'all',
          user_id:res.data[0].PARENT_ID
        }).then(r=>{
          for(var i = 0; i < r.data.length; i++){
            var ia = res.data.find(x=> x.USER_ID == r.data[i].USER_ID);
            if(!ia) continue;
            r.data[i].USER_NAME = ia.USER_NAME;
            var status = "";
            switch(r.data[i].STATUS){
              case 'wait_payment':
                status = '支払待ち';
                break;
              case 'wait_shipping':
                status = '発送待ち';
                break;
              case 'wait_review':
                status = '受取評価待ち';
                break;
              case 'wait_done':
                status = '評価待ち';
                break;
              case 'done':
                status = '評価済み';
                break;
            }
            r.data[i].status = status;
            r.data[i].SEND_FLG = r.data[i].SEND_FLG == '1';
            r.data[i].COM_COUNT = !r.data[i].COM_COUNT? '0': r.data[i].COM_COUNT;
          }
          vm.items = r.data.filter(x=> x.USER_NAME != null).sort(function(a, b) {
            return (a.SELL_DATE > b.SELL_DATE) ? -1 : 1; 
          });
        })
      })
    },
  },
  computed:{
        getPaginateCount: function () {
            return Math.ceil(this.items.length / this.perPage);
        },
        getItems () {
          if(this.items.length == 0) return;
          let start = (this.currentPage - 1) * this.perPage;
          let end = this.currentPage * this.perPage;
         
            return this.items.slice(start, end);
          }
    },
    created:function(){
      let vm =this;
      vm.init();
  },
  mounted: function() {
    $(function() {
      'use strict';
      $("#scrollbar, #scrollbox").on('scroll', function() {
        
        var tableWidth = $('#csvTable').width() + 20;
        
        // var col1 = $('#scrollbox tr th:nth-child(1)').width() + 1;
        // var col2 = $('#scrollbox tr th:nth-child(2)').width() + 1;
        // var col3 = $('#scrollbox tr th:nth-child(3)').width() + 1;
        // var col4 = $('#scrollbox tr th:nth-child(4)').width() + 1;
        if ( $(this).attr('id') === 'scrollbar' ) {
          $('#scrollInner').css('width',tableWidth);
          
          console.log($('#scrollbox tr th:nth-child(4)').width());
          $('#scrollbox').scrollLeft($(this).scrollLeft());
        } else {
          $('#scrollInner').css('width',tableWidth);
          $("#scrollbar").scrollLeft($(this).scrollLeft());
        }
        // $('#scrollbox tr th:nth-child(2)').css('left',col1);
        // $('#scrollbox tr th:nth-child(3)').css('left',col1 + col2);
        // $('#scrollbox tr th:nth-child(4)').css('left',col1 + col2 + col3);
        // $('#scrollbox tr th:nth-child(5)').css('left',col1 + col2 + col3 + col4);
        // $('#scrollbox tr td:nth-child(2)').css('left',col1);
        // $('#scrollbox tr td:nth-child(3)').css('left',col1 + col2);
        // $('#scrollbox tr td:nth-child(4)').css('left',col1 + col2 + col3);
        // $('#scrollbox tr td:nth-child(5)').css('left',col1 + col2 + col3 + col4);
      });
      
    });
  },
  validations:{
    
  
  }
};
</script>

<style lang="scss">
@import "../style/sell.scss";
@import "../style/shipCsv.scss";

@import "../style/auctionRegister.scss";
.sellersV{
    overflow: auto;
    width: 100%;
    max-height: 800px;
}
.sellersV table{
    margin: 0;
    border-spacing: 0;
}
.sellersV th{
    white-space: nowrap;
    position: -webkit-sticky;
    position: sticky;
    top: 0;
    left: 0;
    min-width: 0 !important;
}
.sellersV td{
    white-space: nowrap;
}
.scrollbar {
  width: 100%;
  height: 10px;
  overflow-x: scroll;
  overflow-y: hidden;
}
.scrollbar .inner {
  width: 3700px;
  height: 1px;
}
.scrollbox {
  width: 100%;
  margin-top: 5px;
  overflow-x: scroll;
}
.scrollbox .inner {
  width: 3500px;
  height: 200px;
  margin-bottom: 5px;
  background-color: #F9F8F6;
}
.scrollbox .txt {
  margin: 0;
  font-size: 16px;
  line-height: 1.5;
}
/* スクロールバーのスタイル */
.scrollbar::-webkit-scrollbar,
.scrollbox::-webkit-scrollbar {
  height: 10px;
}
.scrollbar::-webkit-scrollbar-track,
.scrollbox::-webkit-scrollbar-track {
  border-radius: 5px;
}
.scrollbar::-webkit-scrollbar-thumb,
.scrollbox::-webkit-scrollbar-thumb {
  border-radius: 5px;
  background-color: #e7e7e7;
}

// #scrollbox tr th:nth-child(1), #scrollbox tr th:nth-child(2) , #scrollbox tr th:nth-child(3) , #scrollbox tr th:nth-child(4) , #scrollbox tr th:nth-child(5) ,
// #scrollbox tr td:nth-child(1), #scrollbox tr td:nth-child(2) , #scrollbox tr td:nth-child(3) , #scrollbox tr td:nth-child(4) , #scrollbox tr td:nth-child(5) {
//     position: sticky;
//     z-index:5 !important;
// }
// #scrollbox tr td:nth-child(1), #scrollbox tr td:nth-child(2) , #scrollbox tr td:nth-child(3) , #scrollbox tr td:nth-child(4) , #scrollbox tr td:nth-child(5) {
//   background-color: #fff;
//   z-index:4 !important;
// }
#scrollbox tr td{
  border: solid 0.5px #5d8ab5;
}
// #scrollbox tr th:nth-child(1), #scrollbox tr td:nth-child(1){
//   left:0;
// }
</style>